let loggedInUser: string | null = null;

export function getLoggedInUser() {
  return loggedInUser;
}

export function setLoggedInUser(email: string | null) {
  loggedInUser = email;
}
